import preval from 'preval.macro';

module.exports = require(preval`module.exports = process.env.MESSAGES_PATH`)